import { Box, Skeleton } from '@chakra-ui/react';
import { humanizeDurationForChart } from 'views/main/organization/analytics-v3/helpers';
import { useGetAnalyticsXTTAByPriority } from 'views/main/organization/analytics-v3/hooks/useGetAnalyticsData';
import Empty from 'views/main/organization/analytics-v3/icons/empty';
import { HorizontalBasicBar } from '../../../Charts/Bar/Horizontal';
import Error from 'views/main/organization/analytics-v3/components/Error';
import { AxiosError } from 'axios';
const Loading = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 518 277"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 0.3; }
            50% { opacity: 0.7; }
            100% { opacity: 0.3; }
          }
          .loading-element {
            animation: pulse 1.5s ease-in-out infinite;
          }
        `}
      </style>
      <rect className="loading-element" y="5.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        className="loading-element"
        x="250"
        width="30"
        height="219"
        rx="3"
        transform="rotate(90 250 0)"
        fill="#ECEFF3"
      />
      <rect className="loading-element" y="48.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        className="loading-element"
        x="325"
        y="43"
        width="30"
        height="294"
        rx="3"
        transform="rotate(90 325 43)"
        fill="#ECEFF3"
      />
      <rect className="loading-element" y="91.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        className="loading-element"
        x="172"
        y="86"
        width="30"
        height="141"
        rx="3"
        transform="rotate(90 172 86)"
        fill="#ECEFF3"
      />
      <rect className="loading-element" y="134.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        className="loading-element"
        x="208"
        y="129"
        width="30"
        height="177"
        rx="3"
        transform="rotate(90 208 129)"
        fill="#ECEFF3"
      />
      <rect className="loading-element" y="177.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        className="loading-element"
        x="291"
        y="172"
        width="30"
        height="260"
        rx="3"
        transform="rotate(90 291 172)"
        fill="#ECEFF3"
      />
      <rect className="loading-element" y="220.5" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        className="loading-element"
        x="160"
        y="215"
        width="30"
        height="129"
        rx="3"
        transform="rotate(90 160 215)"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="31"
        y="258"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="122"
        y="258"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="213"
        y="258"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="304"
        y="258"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="395"
        y="258"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="486"
        y="258"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
    </svg>
  );
};

export const XTTAByPriority = () => {
  const { data, isLoading, isError, refetch, error } = useGetAnalyticsXTTAByPriority();
  if (isError) {
    return (
      <Box position="relative" height={282}>
        <Error
          onRefreshClick={refetch}
          errorMessage={(error as AxiosError).response?.data?.message}
        />
      </Box>
    );
  }
  if (isLoading) return <Loading />;
  if (!data) return null;
  const isEmpty = data?.length === 0;
  if (isEmpty) return <Empty />;
  return (
    <HorizontalBasicBar
      data={data}
      left={80}
      right={30}
      top={10}
      bottom={30}
      height={282}
      formatter={value => humanizeDurationForChart(value, 1)}
    />
  );
};
